import React from 'react';
import Typography from 'housecall-ui/dist/DesignSystem/DataDisplay/Typography/Typography';
import Grid from 'housecall-ui/dist/DesignSystem/Layout/Grid/Grid';
import WebsiteBuilderAppIcon from 'housecall-ui/dist/IconsAndImages/AppIcons/WebsiteBuilderAppIcon';

import Version3ProTheme from '../../../Version3ProTheme.js';
import WebsiteBuilderButton from '../OtherComponents/WebsiteBuilderButton';

const WebsiteBuilderStrategy = {
  previewInfo: {
    name: 'Website builder',
    iconSvg: <WebsiteBuilderAppIcon size="xlarge" />,
  },
  headerInfo: {
    name: 'Website builder',
    category: 'Built to get you more jobs',
    details: (
      <span>
        Let your customers find and book you online with ease. With Housecall Pro’s Website Builder, you can create your
        own website in under ten minutes.
        <br />
        <br />
        Get a modern and professional site with everything you need. Websites include:
        <ul>
          <li>Online Booking Engine</li>
          <li>Reviews</li>
          <li>FAQs</li>
          <li>Accolades</li>
          <li>Awards</li>
          <li>Photos</li>
          <li>Social media</li>
          <li>A featured video</li>
          <li>Service area</li>
          <li>SEO friendly template</li>
          <li>Testimonials</li>
          <li>Website Chat Bubble (included only on Fixed plan)</li>
        </ul>
        <br />
        Choose a domain during the build process or bring your own.
        <br />
        Already own a domain you love?
        <a
          href="https://help.housecallpro.com/en/articles/3852605-pointing-your-own-domain"
          style={{ color: Version3ProTheme.palette.primary.main }}
          target="_blank"
          rel="noreferrer"
        >
          {' '}
          Click here{' '}
        </a>
        for instructions on how to point your own domain.
      </span>
    ),
    iconSvg: <WebsiteBuilderAppIcon size="xlarge" />,
  },
  price: {
    showBetaButton: false,
    hideToggle: true,
    appActionButton: <WebsiteBuilderButton />,
    price: '',
    description: (
      <Grid container spacing={8}>
        <Grid item xs={8}>
          <Typography align="left" variant="subtitle2">
            <b>Basic (no booking engine)</b>
          </Typography>
          <Typography align="left" variant="body2">
            $12.99/year for domain after the first year
          </Typography>
        </Grid>
        <Grid item xs={4}>
          <Typography align="right" variant="body2">
            $0/mo
          </Typography>
        </Grid>
        <Grid item xs={8}>
          <Typography align="left" variant="subtitle2">
            <b>Fixed</b>
          </Typography>
          <Typography align="left" variant="body2">
            Flat fee for your website every month
          </Typography>
        </Grid>
        <Grid item xs={4}>
          <Typography align="right" variant="body2">
            $25/mo
          </Typography>
        </Grid>
        <Grid item xs={8}>
          <Typography align="left" variant="subtitle2">
            <b>Success </b>
          </Typography>
          <Typography align="left" variant="body2">
            Only pay for months when you get a job booked on your website
          </Typography>
        </Grid>
        <Grid item xs={4}>
          <Typography align="right" variant="body2">
            $49/mo
          </Typography>
        </Grid>
      </Grid>
    ),
  },
  sellingPoints: {
    headline: 'Interested in seeing an example? Click an industry below to check it out!',
    description: '',
    unorderedPoints: [
      <a
        href="https://www.rollnshine.com/"
        style={{ color: Version3ProTheme.palette.primary.main }}
        target="_blank"
        rel="noreferrer"
      >
        Mobile detailing
      </a>,
      <a
        href="https://www.villagedryerventpro.com/"
        style={{ color: Version3ProTheme.palette.primary.main }}
        target="_blank"
        rel="noreferrer"
      >
        Chimney
      </a>,
      <a
        href="https://neal-tekelectric.com"
        style={{ color: Version3ProTheme.palette.primary.main }}
        target="_blank"
        rel="noreferrer"
      >
        Electrical
      </a>,
      <a
        href="https://www.dubsheatingandair.com/"
        style={{ color: Version3ProTheme.palette.primary.main }}
        target="_blank"
        rel="noreferrer"
      >
        HVAC
      </a>,
      <a
        href="https://www.cardinalcr.com/"
        style={{ color: Version3ProTheme.palette.primary.main }}
        target="_blank"
        rel="noreferrer"
      >
        General contractor
      </a>,
      <a
        href="https://www.maidstoservecom.com/"
        style={{ color: Version3ProTheme.palette.primary.main }}
        target="_blank"
        rel="noreferrer"
      >
        Home cleaning
      </a>,
      <a
        href="https://www.emeraldcleaningco.com/"
        style={{ color: Version3ProTheme.palette.primary.main }}
        target="_blank"
        rel="noreferrer"
      >
        Window cleaning and Pressure Washing
      </a>,
      <a
        href="https://www.treadstonecleaning.com/"
        style={{ color: Version3ProTheme.palette.primary.main }}
        target="_blank"
        rel="noreferrer"
      >
        Carpet cleaning
      </a>,
      <a
        href="https://calloasis.com/"
        style={{ color: Version3ProTheme.palette.primary.main }}
        target="_blank"
        rel="noreferrer"
      >
        Plumbing
      </a>,
    ],
  },
};

export default WebsiteBuilderStrategy;
